import React, { useEffect, useState } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { getEntities, createEntity, updateEntity, deleteEntity } from '../services/admin_api';

const Entities = () => {
    const [entities, setEntities] = useState([]);
    const [newEntity, setNewEntity] = useState('');
    const [editingEntity, setEditingEntity] = useState(null);
    const [editingValue, setEditingValue] = useState('');
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);

    useEffect(() => {
        fetchEntities(page, limit);
    }, [page, limit]);

    const fetchEntities = async (pageNumber, limitNumber) => {
        const data = await getEntities(pageNumber, limitNumber);
        setEntities(data);
    };

    const handleAddEntity = async () => {
        if (newEntity) {
            await createEntity({ name: newEntity });
            setNewEntity('');
            fetchEntities(page, limit);
        }
    };

    const handleEditEntity = async (id) => {
        if (editingValue) {
            await updateEntity(id, { name: editingValue });
            setEditingEntity(null);
            setEditingValue('');
            fetchEntities(page, limit);
        }
    };

    const handleDeleteEntity = async (id) => {
        await deleteEntity(id);
        fetchEntities(page, limit);
    };

    const handlePrevPage = () => {
        if (page > 1) {
            setPage(page - 1);
        }
    };

    const handleNextPage = () => {
        setPage(page + 1);
    };

    const handleLimitChange = (e) => {
        setLimit(parseInt(e.target.value, 10));
        setPage(1); // réinitialiser la pagination
    };

    return (
        <div>
            <Header />
            <h1>Entities</h1>
            <div>
                <input
                    type="text"
                    value={newEntity}
                    onChange={(e) => setNewEntity(e.target.value)}
                    placeholder="Add new entity"
                />
                <button onClick={handleAddEntity}>Add</button>
            </div>

            <div style={{ margin: '1rem 0' }}>
                <label htmlFor="limitSelect">Entités par page :</label>
                <select id="limitSelect" value={limit} onChange={handleLimitChange}>
                    <option value={5}>5</option>
                    <option value={10}>10</option>
                    <option value={20}>20</option>
                    <option value={50}>50</option>
                </select>
            </div>

            <table>
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>Name</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {entities.map((entity) => (
                        <tr key={entity.id}>
                            <td>{entity.id}</td>
                            <td>
                                {editingEntity === entity.id ? (
                                    <input
                                        type="text"
                                        value={editingValue}
                                        onChange={(e) => setEditingValue(e.target.value)}
                                    />
                                ) : (
                                    entity.label
                                )}
                            </td>
                            <td>
                                {editingEntity === entity.id ? (
                                    <button onClick={() => handleEditEntity(entity.id)}>Save</button>
                                ) : (
                                    <>
                                        <button
                                            onClick={() => {
                                                setEditingEntity(entity.id);
                                                setEditingValue(entity.name);
                                            }}
                                        >
                                            Edit
                                        </button>
                                        <button onClick={() => handleDeleteEntity(entity.id)}>Delete</button>
                                    </>
                                )}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>

            <div style={{ marginTop: '1rem' }}>
                <button onClick={handlePrevPage} disabled={page === 1}>
                    Précédent
                </button>
                <span style={{ margin: '0 1rem' }}>Page {page}</span>
                <button onClick={handleNextPage}>Suivant</button>
            </div>
            <Footer />
        </div>
    );
};

export default Entities;